/** Linha do tempo do cliente: tudo o que aconteceu com ele, em ordem, numa lista só. */
import { z } from 'zod';
import { Id } from './comum.js';

export const TipoItemLinha = z.enum(['TAREFA', 'COMENTARIO', 'ANEXO', 'ENVIO', 'PEDIDO', 'SOLICITACAO', 'EMAIL', 'ALTERACAO', 'AUDITORIA']);
export type TipoItemLinha = z.infer<typeof TipoItemLinha>;
export const ItemLinhaDoTempo = z.object({ quando: z.string(), tipo: TipoItemLinha, titulo: z.string(), texto: z.string().nullable(), tarefaId: Id.nullable(), quem: z.string().nullable() });
export type ItemLinhaDoTempo = z.infer<typeof ItemLinhaDoTempo>;
export const LinhaDoTempoResposta = z.object({ itens: z.array(ItemLinhaDoTempo), /** para pedir a página seguinte (antes=) */ maisAntigo: z.string().nullable() });
export type LinhaDoTempoResposta = z.infer<typeof LinhaDoTempoResposta>;
export const LinhaDoTempoQuery = z.object({ antes: z.string().optional(), limite: z.coerce.number().int().min(10).max(200).default(60) });
export type LinhaDoTempoQuery = z.infer<typeof LinhaDoTempoQuery>;
